import { render, staticRenderFns } from "./sealManagement.vue?vue&type=template&id=4b3ec163&scoped=true&"
import script from "./sealManagement.vue?vue&type=script&lang=js&"
export * from "./sealManagement.vue?vue&type=script&lang=js&"
import style0 from "./sealManagement.vue?vue&type=style&index=0&id=4b3ec163&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3ec163",
  null
  
)

export default component.exports